import React, { useState } from "react";
import "../Styles/Hero2.css";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import IntlMessages from "../../../intl/IntlMessages";
import heroImage1 from "../../../assets/img/website-hosting-concept-with-bright-light.webp";
import heroImage2 from "../../../assets/img/business-5475661_1920.webp";
import heroImage3 from "../../../assets/img/smartphone-6701409_1920.webp";
import heroImage4 from "../../../assets/img/building.jpg";
import heroImage5 from "../../../assets/img/property.jpg";
import DownLoadApp from "./downloadApp";
import AlertMessage from "../../../layouts/errorAlert";

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  const [alert, setAlert] = useState({
    show: false,
    variant: "danger",
    message: <IntlMessages id="app.popup" />,
  });

  const handleDownload = () => {
    setAlert((prev) => ({ ...prev, show: true }));
    return;
  };

  const slides = [
    {
      image: heroImage1,
      title: <IntlMessages id="navigation.realEstate" />,
      description: [
        <IntlMessages id="expertise.realEstateDescription" />,
        <IntlMessages id="content.realEstateManagement" />,
        <IntlMessages id="content.realEstateInvestment" />,
      ],
      highlight: <IntlMessages id="content.realEstateTrust" />,
    },
    {
      image: heroImage2,
      title: <IntlMessages id="eventManagement.eventOrganization" />,
      description: [
        <IntlMessages id="eventManagement.title" />,
        <IntlMessages id="content.beautyDecor" />,
        <IntlMessages id="eventManagement.toolsEquipment" />,
      ],
      highlight: <IntlMessages id="eventManagement.buildMoment" />,
    },
    {
      image: heroImage3,
      title: <IntlMessages id="content.itServices" />,
      description: [
        <IntlMessages id="it.advancedDigital" />,
        <IntlMessages id="content.itSecurity" />,
        <IntlMessages id="content.networkTelecom" />,
      ],
      highlight: <IntlMessages id="content.technologyExcellence" />,
    },
    {
      image: heroImage4,
      title: <IntlMessages id="content.socialPlatform" />,
      description: [
        <IntlMessages id="content.socialPlatform1" />,
        <IntlMessages id="content.socialPlatform2" />,
        <IntlMessages id="content.socialPlatform3" />,
      ],
      highlight: <IntlMessages id="content.socialPlatform4" />,
    },
    {
      image: heroImage5,
      title: <IntlMessages id="content.btp" />,
      description: [
        <IntlMessages id="content.btp1" />,
        <IntlMessages id="content.btp2" />,
        <IntlMessages id="content.btp3" />,
      ],
      highlight: <IntlMessages id="content.btp4" />,
    },
  ];

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="hero-section">
      <Carousel
        activeIndex={index}
        onSelect={handleSelect}
        interval={50000}
        fade
        controls={true}
        pause={false}
        className="hero-carousel"
      >
        {slides.map((slide, idx) => (
          <Carousel.Item key={idx} className="carousel-item-custom">
            <div
              className="carousel-background"
              style={{ backgroundImage: `url(${slide.image})` }}
            />
            <div className="carousel-overlay"></div>
            <div className="container h-100">
              <div className="row h-100 align-items-center">
                <div className="col-lg-7 text-white hero-text-column">
                  <div className="hero-content">
                    <h1 className="hero-title animate-in">{slide.title}</h1>
                    <div className="hero-description">
                      {slide.description.map((text, i) => (
                        <p
                          key={i}
                          className={`lead mb-3 fade-in-up delay-${i + 1}`}
                        >
                          {text}
                        </p>
                      ))}
                      <p className="highlight-text fade-in-up delay-4">
                        {slide.highlight}
                      </p>
                      <DownLoadApp handleDownload={handleDownload} />
                    </div>
                    <div className="hero-buttons fade-in-up delay-5">
                      <Link
                        to="/services"
                        className="btn btn-xs custom-btn btn-outline-light"
                      >
                        <IntlMessages id="content.ourServices" />
                      </Link>
                      <Link
                        to="/contact"
                        className="btn btn-xs custom-btn btn-outline-light"
                      >
                        <IntlMessages id="content.getInTouch" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      <AlertMessage alert={alert} setAlert={setAlert} />
    </section>
  );
};

export default HeroSection;
